import React from "react";
import { BasketSurveyItem } from "../../../../models/Survey";
import { MdCheck, MdConfirmationNumber } from "react-icons/md";

interface IProps {
  items: BasketSurveyItem[];
  currentIndex: number;
}

const SurveyAssortStepper: React.FC<IProps> = ({ items, currentIndex }) => {
  return (
    <div className="survey-assort-stepper">
      <div className="survey-assort-stepper__track">
        {items.map((item, index) => {
          const isPast = index < currentIndex;
          const isActive = index === currentIndex;

          let stateClass = "survey-assort-stepper__item";
          if (isPast) stateClass += " survey-assort-stepper__item--past";
          if (isActive) stateClass += " survey-assort-stepper__item--active";
          if (!isActive && !isPast) stateClass += " survey-assort-stepper__item--future";

          return (
            <div key={`${item.assortIds}-${item.instanceIndex}`} className={stateClass}>
              <div className="survey-assort-stepper__icon">
                {isPast ? <MdCheck size={14} /> : <MdConfirmationNumber size={14} />}
              </div>
              <div className="survey-assort-stepper__info">
                <span className="survey-assort-stepper__name caption">{item.assortName}</span>
                {item.validFrom && (
                  <span className="survey-assort-stepper__date caption">{item.validFrom}</span>
                )}
              </div>
              {index < items.length - 1 && (
                <div className={`survey-assort-stepper__connector${isPast ? " survey-assort-stepper__connector--done" : ""}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SurveyAssortStepper;
